export var createMuiMenuOverrides = function (_a) {
    var tokens = _a.tokens;
    return {
        defaultProps: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            // FIXME: No typing for this. Address during Component Migration
            // getContentAnchorEl: null,
        },
        styleOverrides: {
            paper: {
                border: "1px solid ".concat(tokens.color_border_bold),
                minWidth: 175,
            },
        },
    };
};
